import { ActionTypes } from "../actions/PageSetting";

function pageSetting(state = {}, action = {}) {
    switch (action.type) {
        case ActionTypes.UPDATE_SELECTED_TAB_INDEX:
            return { ...state, selectedTabIndex: action.selectedTabIndex };
        default:
            return state;
    }
}

export default pageSetting;
